import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=770c2dfe&"
import script from "./ItemGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports